import { AddressFieldName } from './enums';

export type USState = {
  abbreviation: string;
  countryId: number;
  market: string;
  name: string;
};

export type UKAddress = {
  moniker: string;
  partialAddress: string;
};

export type AddressFieldsType = Partial<Record<AddressFieldName, string>>;

export type Address = {
  address?: string;
  addressLine2?: string;
  addressLine3?: string;
  addressLine4?: string;
  city: string;
  cityFrench?: string;
  idCountry?: number;
  country?: string;
  county?: string;
  houseNumber?: string;
  houseNumberAddition?: string;
  postCode?: string;
};
